import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {SystemlogService} from '../../../services/systemlog.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {Observable, of} from 'rxjs';
import * as featureActions from '../../index';
import {catchError, combineLatest, map, mergeMap, switchMap, withLatestFrom} from 'rxjs/operators';
import { SystemlogActions } from '../actions/systemlog.actions';

@Injectable()
export class SystemlogEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private systemlogService = inject(SystemlogService);

  constructor() {}

  ReadSystemLog$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.SystemlogActionTypes.GetSystemlogs),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      // let param = {};
      // if (user.authority === 2 || user.authority === 1) {
      //   param = {
      //     otp: action.payload.otp,
      //     LogType: action.payload.LogType,
      //     Period: action.payload.Period,
      //     acode: action.payload.acode
      //   };
      // } else {
      //   param = {
      //     otp: user.otp,
      //     LogType: action.payload.LogType,
      //     Period: action.payload.Period,
      //   };
      // }
      const payload = { ...action.payload, otp: user.otp };
      return this.systemlogService.ReadSystemLog(payload).pipe(
        map((res: any) => {
          if (res.msg.body) {
            return new featureActions.UpsertSystemlogs(res.msg.body);
          } else {
            return new featureActions.GetSystemlogsFail();
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return of(new featureActions.GetSystemlogsFail());
        })
      );
    })
  ));
  ReadSystemLogType$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.SystemlogActionTypes.GetSystemlogsType),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      return this.systemlogService.ReadSystemLogType(user.otp).pipe(
        map((res: any) => {
          if (res.msg.body) {
            return new featureActions.UpsertSystemlogsType(res.msg.body);
          } else {
            return new featureActions.GetSystemlogsTypeFail();
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return of(new featureActions.GetSystemlogsTypeFail());
        })
      );
    })
  ));
}
